import { Component, OnInit, Input, OnChanges} from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms'
import { AutoDate } from '../_models/AutoDate';
import { debounceTime, map, distinctUntilChanged } from 'rxjs/operators';
import { PhoneReportsService } from '../services/phone-reports.service';

@Component({
  selector: 'app-select-date-form',
  templateUrl: './select-date-form.component.html',
  styleUrls: ['./select-date-form.component.scss']
})
export class SelectDateFormComponent implements OnInit, OnChanges {
  @Input() isStartQueryServer: boolean;

  chooseDatePeriod: FormGroup;
  autoDates: AutoDate[] = [
    {
      value: 'ALL_TIME',
      time: -1
    },
    {
      value: 'LAST_DAY',
      time: 0
    }, 
    {
      value: 'LAST_TWO_DAYS',
      time: 172800000
    },
    {
      value: 'LAST_WEEK',
      time: 604800000
    },
    {
      value: 'LAST_MONTH',
      time: 2592000000
    }
  ];
  startDate;
  endDate;
  autoDate;
  maxDate;
  minStartDate;
  minEndDate;

  constructor(
    private fb: FormBuilder,
    public phoneReports: PhoneReportsService,
  ) { }

  ngOnInit() {
    this.phoneReports.grtMinDateReports().subscribe(res => {
      this.minStartDate = new Date(res['min_date']);      
    });
    this.initForm();
    this.chooseDatePeriod.valueChanges.pipe(
      debounceTime(100),
      map((val: any) => val),
      distinctUntilChanged()
    ).subscribe(timePeriod => {
      this.minEndDate = timePeriod.inputStartDate;
      this.phoneReports.timePeriod.next({...timePeriod});
    });
  }

  private initForm() {
    this.maxDate = new Date();
    this.chooseDatePeriod = this.fb.group({
      selectAutoDate: '',
      inputStartDate: ['', Validators.required],
      inputEndDate: ['', Validators.required]
    });
  }

  ngOnChanges() {
    if (this.chooseDatePeriod) {
      if (this.isStartQueryServer) {
        this.chooseDatePeriod.controls['selectAutoDate'].disable();
        this.chooseDatePeriod.controls['inputStartDate'].disable();
        this.chooseDatePeriod.controls['inputEndDate'].disable();
      } else  {
        this.chooseDatePeriod.controls['selectAutoDate'].enable();
        this.chooseDatePeriod.controls['inputStartDate'].enable();
        this.chooseDatePeriod.controls['inputEndDate'].enable();
      }
    }
  }

  onSelect(f) {    
    const currentDate = new Date();
    this.startDate = new Date(currentDate.getTime() - f.value.selectAutoDate);
    this.endDate = new Date();
    if (f.value.selectAutoDate === -1) {
      this.startDate = this.minStartDate;
      this.endDate = new Date();
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/phone-reports/select-date-form/select-date-form.component.ts